import React from "react";

import { LAYOUTS_NO_ITEMS_STRINGS } from "constants/constantStrings";

import "./index.scss";

const NoLayoutsView = () => (
  <div className="no-layout-view">
    <label className="dupont-form-label">{LAYOUTS_NO_ITEMS_STRINGS.noLayoutsTitle}:</label>
    <ul>
      <li className="descriptionText">
        <div className="no-layout-view__item">
          {LAYOUTS_NO_ITEMS_STRINGS.noLayoutsOption1}
          <span className="add-layout-icon" />
        </div>
      </li>
      <li className="descriptionText">
        <div className="no-layout-view__item">{LAYOUTS_NO_ITEMS_STRINGS.noLayoutsOption2}</div>
      </li>
    </ul>
  </div>
);

export default NoLayoutsView;
